package com.exura.components.pageTypography

import androidx.compose.runtime.Composable
import com.exura.surface
import com.exura.transparent
import com.exura.ui.Dimens
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.RowScope
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.lightened
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexGrow
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.style.ComponentKind
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.CssStyleVariant
import com.varabyte.kobweb.silk.style.addVariant
import com.varabyte.kobweb.silk.style.selectors.hover
import com.varabyte.kobweb.silk.style.selectors.lastChild
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.border
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.times


@Composable
internal fun GeneralListEntry(
    modifier: Modifier = Modifier,
    variant: CssStyleVariant<ListEntryKind>? = null,
    content: @Composable RowScope.() -> Unit,
) {
    Row(
        modifier = ListEntryStyle.toModifier(variant).then(modifier),
        horizontalArrangement = Arrangement.spacedBy(Dimens.listEntryLeftRightSpacer)
    ) {
        content()
    }
}

sealed interface ListEntryKind : ComponentKind

val ListEntryStyle = CssStyle<ListEntryKind> {
    val palette = colorMode.toPalette()
    base {
        Modifier
            .fillMaxWidth()
            .padding(leftRight = Dimens.listEntryIndent, topBottom = Dimens.listEntryWrapping)
            .borderBottom(Dimens.listEntrySeparatorWidth, LineStyle.Solid, palette.border)

    }

    lastChild {
        Modifier
            .borderBottom(Dimens.listEntrySeparatorWidth, LineStyle.None, palette.border)
    }
}

val HoverableListEntryVariant = ListEntryStyle.addVariant {
    val palette = colorMode.toPalette()
    base {
        Modifier
            .cursor(Cursor.Pointer)

    }
    hover {
        Modifier
            .backgroundColor(palette.surface)
            .fontWeight(FontWeight.Medium)
    }
}

val HoverableListEntrySurfaceVariant = ListEntryStyle.addVariant {
    val palette = colorMode.toPalette()
    base {
        Modifier
            .cursor(Cursor.Pointer)

    }
    hover {
        Modifier
            .backgroundColor(palette.surface.lightened())
            .fontWeight(FontWeight.Medium)
    }
}

val  SelectedListEntryVariant = ListEntryStyle.addVariant {
    val palette = colorMode.toPalette()

    base {
        Modifier
            .backgroundColor(palette.surface)
            .fontWeight(FontWeight.Medium)
    }
}

sealed interface ListEntryImageKind : ComponentKind

val ListEntryImageStyle = CssStyle<ListEntryImageKind> {
    val palette = colorMode.toPalette()

    base {
        Modifier
            .backgroundColor(if (colorMode.isDark) palette.color else palette.transparent)
            .color(if (colorMode.isDark) palette.background else palette.color)
            .size(Dimens.listEntryImageSize)
            .border(
                width = Dimens.listEntryImageBorderWidth,
                style = LineStyle.Solid,
                color = palette.border
            )
            .borderRadius(Dimens.listEntryBackgroundBorderRadius)
            .flexShrink(0)
            .flexGrow(0)
    }

}
val ListEntryImageLargeVariant = ListEntryImageStyle.addVariant {
    base {
        Modifier
            .size(2 * Dimens.listEntryImageSize)
    }
}

val ListEntryImageNoImageVariant = ListEntryImageStyle.addVariant {
    val palette = colorMode.toPalette()

    base {
        Modifier
            .height(Dimens.spacingNone)
            .backgroundColor(palette.transparent)
            .border(
                width = Dimens.listEntryImageBorderWidth,
                style = LineStyle.Solid,
                color = palette.transparent
            )
    }
}
